import React, { useEffect, useState } from "react";
import GenericInvoiceTable from "../tables/GenericInvoiceTable";
import useApi from "../../hooks/useApi";
import sampleIssueConfig from "../config/SampleIssueTableConfig";

const SampleIssueTable = ({
  items,
  onItemsChange,
  setShowSidebar,
  setItemInfo,
  setCurrentLocation,
  extraFields = [],
  purchaseData,
  initialRowUnitOptions,
  isOtherCostEnabled,
  setIsOtherCostEnabled,
  otherCosts = [],
  setOtherCosts,
  BASE_URL,
  COMPANY_CODE,
  DEPARTMENT_NO,
  itemPricing,
  setItemPricing,
  currentStockInhand,
  setCurrentStockInhand,
  setFocusedProductCode,
}) => {
  const { request, loading } = useApi();
  const [salesmanList, setSalesmanList] = useState([]);
  const fetchSalesmanList = async () => {
    const url = `${BASE_URL}/api/MasterCount/${COMPANY_CODE}/SALESPERSONLIST/-/${DEPARTMENT_NO}`;
    try {
      const response = await request({
        url: url,
        method: "GET",
        timeout: 10000,
      });
      console.log("Response", response);

      const mappedSalesmen = (response || []).map((s) => ({
        label: s.NAME,
        value: s.EMP_ID,
      }));

      setSalesmanList(mappedSalesmen);
    } catch (err) {
      console.error("Error loading data:", err);
      setSalesmanList([]);
    }
  };

  useEffect(() => {
    fetchSalesmanList();
  }, []);
  // Hide Amount field if useraccess contains AC, SW, or ST
  let userAccess = "";
  try {
    const userObj = JSON.parse(localStorage.getItem("currentUser"));
    userAccess = userObj?.[0]?.useraccess || "";
  } catch (e) { }

  const shouldHideAmount = ["AC", "SW", "ST"].some((code) =>
    userAccess.includes(code),
  );

  // Dynamically filter columns if needed
  let filteredConfig = sampleIssueConfig;
  if (shouldHideAmount) {
    const filteredOrder = sampleIssueConfig.defaultColumnsOrder.filter(
      (col) => col !== "Amount",
    );
    const filteredFieldMap = { ...sampleIssueConfig.columnFieldMap };
    delete filteredFieldMap["Amount"];
    filteredConfig = {
      ...sampleIssueConfig,
      defaultColumnsOrder: filteredOrder,
      columnFieldMap: filteredFieldMap,
    };
  }

  return (
    <GenericInvoiceTable
      items={items}
      onItemsChange={onItemsChange}
      setShowSidebar={setShowSidebar}
      setItemInfo={setItemInfo}
      setCurrentLocation={setCurrentLocation}
      extraFields={extraFields}
      documentData={purchaseData}
      config={filteredConfig}
      initialRowUnitOptions={initialRowUnitOptions}
      showOtherCostButton={false}
      onShowOtherCost={() => setIsOtherCostEnabled?.((v) => !v)}
      isOtherCostVisible={false}
      otherCosts={otherCosts}
      setOtherCosts={setOtherCosts}
      salesmanOptions={salesmanList}
      itemPricing={itemPricing}
      setFocusedProductCode={setFocusedProductCode}
      currentStockInhand={currentStockInhand}
      setCurrentStockInhand={setCurrentStockInhand}
      setItemPricing={setItemPricing}
      documentType={"SAMPLEISSUE"}
    />
  );
};

export default SampleIssueTable;
